import { Collapse, Flex, Transition } from '@mantine/core';

import { BannerType } from 'models';

import { useBannerMessage } from 'hooks/use-banner-message';

export const FullWidthBannerMessage = () => {
    const { BannerContent, showBanner } = useBannerMessage(BannerType.FullWidth);

    return (
        <Transition mounted={showBanner} transition="slide-down">
            {(styles) => (
                <Flex
                    py={6}
                    px="xs"
                    align="center"
                    justify="space-between"
                    className="gradient-cyan-green-background-light"
                    style={styles}
                >
                    {BannerContent}
                </Flex>
            )}
        </Transition>
    );
};
